import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9dae72d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "font-bold text-7xl text-text-white" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "text-4xl"
}
const _hoisted_5 = {
  key: 1,
  class: "py-24"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold" }, "Dit verhaal heeft nog geen assets", -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_on_boarding_card = _resolveComponent("on-boarding-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_masonry = _resolveComponent("the-masonry")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(_ctx.storyNumber == 1 ? 'pb-12' : 'py-12')
  }, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(`flex justify-center items-center mr-12 h-48 w-48 z-40 rounded-full bg-${_ctx.storyColor} shadow-${_ctx.storyColor}`)
      }, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.storyNumber), 1)
      ], 2),
      _createElementVNode("div", null, [
        _createElementVNode("h2", {
          class: _normalizeClass(`text-5xl font-bold text-${_ctx.storyColor}`)
        }, _toDisplayString(_ctx.story.title[0].value), 3)
      ])
    ]),
    (_ctx.storyEntities.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createVNode(_component_the_masonry, {
            ref: "masonry",
            tiles: _ctx.entityData,
            entities: _ctx.entityData,
            loading: _ctx.loading,
            "generate-url": _ctx.generateUrl,
            "no-image-url": _ctx.noImageUrl,
            "show-load-more": false,
            "items-each-load": _ctx.entityData.length
          }, {
            tile: _withCtx(({ entity }) => [
              _createVNode(_component_router_link, {
                to: { path: '/touchtable/' + entity.id },
                class: "absolute top-0 left-0 w-full h-full",
                onClick: ($event: any) => (_ctx.handleTouchtableNavigation(entity))
              }, {
                default: _withCtx(() => [
                  (entity.seen)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(`
              absolute
              top-4
              left-4
              flex
              justify-center
              items-center
              rounded-full
              w-14
              h-14
              bg-${_ctx.storyColor}
              text-text-white text-3xl
            `)
                      }, [
                        _createVNode(_component_base_icon, {
                          icon: "check",
                          class: "stroke-current fill-current stroke-2"
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  (
                _ctx.onBoardingEntityId == entity.id &&
                _ctx.isLastSeenStory &&
                _ctx.onBoardingState.status == 'started' &&
                _ctx.onBoardingState.currentStepName == 'goToTouchTable'
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_on_boarding_card, {
                          showCard: true,
                          cardTitle: _ctx.t('touchtable.onBoarding.goToTouchTable.title'),
                          cardDescription: _ctx.t('touchtable.onBoarding.goToTouchTable.description'),
                          showPreviousButton: false,
                          placement: "right",
                          onNextButtonClicked: ($event: any) => (_ctx.handleTouchtableNavigation(entity, true))
                        }, null, 8, ["cardTitle", "cardDescription", "onNextButtonClicked"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to", "onClick"])
            ]),
            _: 1
          }, 8, ["tiles", "entities", "loading", "generate-url", "no-image-url", "items-each-load"])
        ]))
      : (_openBlock(), _createElementBlock("section", _hoisted_5, _hoisted_7))
  ], 2))
}